export default __webpack_public_path__ + "static/media/Japanese(JP).7adc6039.svg";